import { Page } from "v2/components";
import { ListContracts } from "./ListContracts";

/**
 * /workspaces?buyer_id=123&seller_id=312?tab=contratos
 */
export function WorkspaceListContracts() {
  // APi call can be done here (but what about the other pages?)

  return (
    <Page title="Contratos">
      <Page.Tab name="Contratos">
        <ListContracts />
      </Page.Tab>
    </Page>
  );
}
